import {
  CustomerSubscriptionApiModel,
  CustomerSubscriptionModel,
} from './customerSubscription.model';

export const customerSubscriptionAdapter = (
  subscription: CustomerSubscriptionApiModel
): CustomerSubscriptionModel => ({
  claimPeriod: subscription.claim_period,
  coursesPerPeriod: subscription.courses_per_period,
  expiredAt: subscription.expired_at,
  id: subscription.id,
  title: subscription.title,
  withHomeworks: subscription.with_homeworks,
});
